import { Button, Icon, keyframes, useToast } from '@chakra-ui/react'
import { FiDownload, FiRefreshCw } from 'react-icons/fi'
import { useFilterContext } from '@/features/filters/context'
import { t } from '@/lib/helpers'
import { ERROR_TOAST_CONFIG } from '@/lib/constants'
import { useAdminPollingPageViewCsv } from '@/features/admins/page_views/hooks/useAdminPageViewsApi'
import {
  ADMIN_PAGE_VIEW_CSV_DOWNLOAD
} from '@/features/admins/page_views/constants'

const spin = keyframes`from { transform: rotate(0deg); } to { transform: rotate(360deg); }`;

function AdminPageViewCsvDownload() {
  const { meta } = useFilterContext();
  const { startExport, isLoading } = useAdminPollingPageViewCsv();
  const toast = useToast();

  const handleExport = () => {
    const { company_id, start_date, end_date, url } = meta;
    if (company_id && start_date && end_date && url?.length) {
      startExport({ company_id, start_date, end_date, domain: url });
    } else {
      toast({
        ...ERROR_TOAST_CONFIG,
        description: ADMIN_PAGE_VIEW_CSV_DOWNLOAD.DESCRIPTION,
      });
    }
  };

  const buttonIcon = isLoading ? <Icon as={FiRefreshCw} animation={`${spin} infinite 2s linear`} /> : <Icon as={FiDownload} />;

  return (
    <Button size="lg" variant="outline" leftIcon={buttonIcon} disabled={isLoading} onClick={handleExport}>
      {isLoading ? 'Exporting...' : 'Download .CSV'}
    </Button>
  );
}

export default AdminPageViewCsvDownload;
